<style lang="scss">
  .print-on-site-details{
    b {
      display: block;
    }
  }
</style>

<!-- eslint-disable -->
<template>
  <b-card class="print-on-site-details">
    <div class="row">
      <section class="col-12 d-flex">
        <b-button v-if="post.pdf_file_url" @click="viewPdf(post.pdf_file_url)" class="btn-success mr-1">View PDF</b-button>
      </section>
    </div>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  export default {
    components: {},
    props: {
      post: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        loading: false,
        printQueueUrl: '',
      };
    },
    mounted() {

    },
    methods: {
      viewPdf(url) {
        window.open(url);
      },
    },
  };
</script>
